<h1
    mat-dialog-title
    class="h1">
    {{ 'ECMR.ecmr_editor.save_as_template' | translate }}
</h1>
<mat-dialog-content
    [formGroup]="templateNameDialogFormGroup"
    class="p-2">
    <mat-form-field>
        <mat-label>{{
            'ECMR.ecmr_editor.template_name' | translate
        }}</mat-label>
        <input
            formControlName="templateName"
            required
            matInput />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-flat-button
        color="warn"
        (click)="closeDialog()">
        {{ 'ECMR.common.cancel' | translate }}
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
    <button
        mat-flat-button
        color="primary"
        (click)="saveTemplateName()"
        [disabled]="!this.templateNameDialogFormGroup.valid">
        {{ 'ECMR.common.save' | translate }}
        <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
    </button>
</mat-dialog-actions>
